import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isNaN from 'lodash/isNaN';
import isEmpty from 'lodash/isEmpty';
import split from 'lodash/split';
import classNames from 'classnames';

// Components
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';


function PullIntoTicket({ triageItem, ticket, route, updateTriageItem }) {
  const [, model, id] = split(route.pathname, '/');

  if (model !== 'tickets' || !id || isNaN(Number(id))) return null;

  return (
    <Tooltip
      elementType="li"
      title={`Pull into ticket "${ticket && ticket.description}"`}
      onClick={() => updateTriageItem({ id: triageItem.id, ticket: { id }, status: 'Resolved' })}
      className={classNames('triage-option-pull-into-ticket', { disabled: !isEmpty(triageItem.ticket) }, 'triage-option-header')}
    >
      <SVG src="svg/chevron-left.svg" className="triage-option-icon pull-into-ticket" />
    </Tooltip>
  );
}

PullIntoTicket.propTypes = {
  triageItem: PropTypes.object.isRequired,
  updateTriageItem: PropTypes.func.isRequired,
  ticket: PropTypes.object,
  route: PropTypes.object
};

// Exports
export default connect((state) => ({
  ticket: state.tickets.ticket,
  route: state.location
}))(PullIntoTicket);
